<template>
  <v-card-list :title="title" ref="top">
    <!-- Show at the top the active value -->
    <v-slide-x-transition mode="out-in">
      <div class="mb-2">
        <v-subheader>Valor seleccionado</v-subheader>
        <v-item-tile
          v-if="activeMappedItem"
          active
          :item="activeMappedItem"
          :item-text="mappedItemsTextProperty"
        />
        <v-list-tile v-else class="grey--text font-italic">No hay ningún valor seleccionado todavía</v-list-tile>
      </div>
    </v-slide-x-transition>
    <!-- The title of the values and a switch to change between the raw values or the mapped ones -->
    <v-items-list-switch />
    <!-- The values to show in the list -->
    <v-item-tile
      v-for="(item, index) in itemsToShow"
      :active="isActive(item)"
      @click="setActiveAndGoToTop(item)"
      :item="item"
      :item-text="mappedItemsTextProperty"
      :key="index"
      :opaque="isOpaque(item)"
    />
    <!-- A message to show if there are no items -->
    <v-list-tile
      v-if="!filteredMappedItems || !filteredMappedItems.length"
      class="grey--text font-italic"
    >No hay valores que mostrar</v-list-tile>
  </v-card-list>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import VCardList from "./CardList";
import VItemsListSwitch from "./ItemsListSwitch";
import VItemTile from "./ItemTile";

/**
 * A component to show the list of values to map or the mapped values.
 */
export default {
  components: {
    VCardList,
    VItemsListSwitch,
    VItemTile
  },
  computed: {
    ...mapGetters("valueMapping", [
      "filteredMappedItems",
      "groupedMappedItems",
      "showingMappedValues"
    ]),
    ...mapState("valueMapping", [
      "activeMappedItem",
      "feature",
      "mappedItems",
      "showingMappedValues"
    ]),
    /* Get the not already mapped items or the mapped values according to the "showingMappedValues" flag */
    itemsToShow() {
      return this.showingMappedValues
        ? this.groupedMappedItems
        : this.filteredMappedItems.filter(item => !item.mapped);
    },
    /**
     * Get the property to show of the items in the list according to the showingMappedValue
     * of the state that indicates to show the mapped value instead of the raw one.
     */
    mappedItemsTextProperty() {
      return this.showingMappedValues ? "mapped" : "value";
    },
    /* The title to show to indicate that we are seeing the values of a given feature */
    title() {
      return `Valores del atributo "${this.feature.name}"`;
    }
  },
  methods: {
    ...mapMutations("valueMapping", ["setActiveMappedItem"]),
    /**
     * Returns a boolean indicating if the item is the active one.
     */
    isActive(item) {
      if (!this.activeMappedItem) return false;
      const activeValue = this.activeMappedItem[this.mappedItemsTextProperty];
      const value = item[this.mappedItemsTextProperty];
      return activeValue === value;
    },
    /**
     * Returns a boolean to indicate if there is an active value and this item is not
     * the active one to opaque it.
     */
    isOpaque(item) {
      return this.activeMappedItem && !this.isActive(item);
    },
    setActiveAndGoToTop(item) {
      this.setActiveMappedItem(item);
      this.$vuetify.goTo(this.$refs.top, { offset: 150 });
    }
  }
};
</script>